import React from 'react';

import { Card } from '../../../components/card/card';
import CircularProgress from '../../../components/circular-progress/circlular-progress';
import { Text } from '../../../components/text/text';
import { Title } from '../../../components/title/title';

type SpeedCardProps = {
  title: string | React.ReactNode;
  content: string | React.ReactNode;
  circularProgressValue?: number;
  circularProgressValueSuffix?: string;
  animationName?: string;
  afterContent?: any;
  icon?: any;
  enableAnimation?: boolean;
  animationSpeed?: number;
  className: string;
};

export const SpeedCardComponent: React.FC<SpeedCardProps> = ({
  title,
  content,
  circularProgressValue,
  circularProgressValueSuffix,
  animationName,
  afterContent,
  icon,
  enableAnimation,
  animationSpeed,
  className
}) => (
  <Card
    border="large"
    className={className}
    afterContent={afterContent}
    content={
      <React.Fragment>
        <Title className="rc-rounded-card__title" level="3" weight="bold" align="left">
          {title}
        </Title>
        <Text className="rc-rounded-card__text" size="large" align="left">
          {content}
        </Text>
      </React.Fragment>
    }
    icon={
      <CircularProgress
        className="rc-rounded-card__progress"
        filledColor="#0C1938"
        unfilledColor="rgba(12, 25, 56, 0.3)"
        value={circularProgressValue}
        valueSuffix={circularProgressValueSuffix}
        enableAnimation={enableAnimation}
        animationSpeed={animationSpeed}
        animationName={animationName}
      >
        {icon}
      </CircularProgress>
    }
  />
);
